export default __webpack_public_path__ + "static/media/DeckedOut_159x150.e1c8631f.png";